import Utils from "../utils/Utils";

const FALLBACK_BUSINESS_PROFILE_JWT =
  "eyJhbGciOiJIUzI1NiJ9.eyJsYXN0TmFtZSI6IllneSIsInN1YiI6IllneSMzMiIsImlzUm9vdCI6ZmFsc2UsImlzQWN0aXZlIjp0cnVlLCJzdWZmaXgiOiI5NjEiLCJ1c2VyRGV0YWlscyI6e30sImZpcnN0TmFtZSI6IkhoIiwibG9ja2VkQWNjb3VudCI6ZmFsc2UsInBob25lTnVtYmVyIjoiODE0NTM0NTgiLCJuYW1lIjoiSGggWWd5IiwiaWQiOiJkMjgzYjRlZi03NzA1LTQ3NzUtOTVjMC01ZGNiMzJkNzBlOTYiLCJleHAiOjE3Nzk5NDIwMDAsImlhdCI6MTc3ODE0MjAwMCwidXNlcm5hbWUiOiJZZ3kjMzIifQ.BVWnf5qdAeXubPGnh03qvRzqfuZm2wQMLwXJOTsKD0A";

const businessProfileController = {
  getBusinessProfileTypesAndCategories: ({ jwt, Authorization } = {}) => {
    return Utils.controller(
      "api/businessProfile/v1/getBusinessProfileTypesAndCategories",
      "",
      "GET",
      "",
      true,
      jwt || Authorization || FALLBACK_BUSINESS_PROFILE_JWT,
      true,
    );
  },
};

export default businessProfileController;
